// Tappollo Media Mock Data

export const stats = [
  { value: "100,000+", label: "Mobile app studios in the world" },
  { value: "1,000+", label: "With multiple self-published apps" },
  { value: "10+", label: "Apps featured in Apple commercials" },
  { value: "1", label: "Optimized for startup founders" }
];

export const clients = [
  { name: "WeWork", logo: "https://cdn.prod.website-files.com/6129dde468e4647da7ce955e/612cd8488b06dbbda41f889d_WeWork.svg" },
  { name: "Discovery", logo: "https://cdn.prod.website-files.com/6129dde468e4647da7ce955e/6135c425fb865f96b97fb028_Discovery.svg" },
  { name: "Timehop", logo: "https://cdn.prod.website-files.com/6129dde468e4647da7ce955e/612cd847edcb44ae4ae78e10_Timehop.svg" },
  { name: "iHeartRadio", logo: "https://cdn.prod.website-files.com/6129dde468e4647da7ce955e/612cd8478633d6a9e3e1d682_iHeartRadio.svg" },
  { name: "Walmart", logo: "https://cdn.prod.website-files.com/6129dde468e4647da7ce955e/6135c4224d8f80a365a9be15_Walmart.svg" },
  { name: "Grailed", logo: "https://cdn.prod.website-files.com/6129dde468e4647da7ce955e/6135c424ffbafa74401e129a_Grailed.svg" },
  { name: "Clear", logo: "https://cdn.prod.website-files.com/6129dde468e4647da7ce955e/6135c423ecf1c757be70a37b_Clear.svg" },
  { name: "Seven Rooms", logo: "https://cdn.prod.website-files.com/6129dde468e4647da7ce955e/6135c4215aa01076ba726f93_Seven%20Rooms.svg" },
  { name: "MakeSpace", logo: "https://cdn.prod.website-files.com/6129dde468e4647da7ce955e/612cd848196e2637dfc9431c_MakeSpace.svg" },
  { name: "Jet", logo: "https://cdn.prod.website-files.com/6129dde468e4647da7ce955e/613f1dbf41d3ae729e23df70_jet%20icon.svg" }
];

export const portfolio = [
  {
    id: 1,
    name: "iHeart Radio",
    category: "MEDIA & ENTERTAINMENT",
    platforms: "iOS • CarPlay",
    image: "https://cdn.prod.website-files.com/61535d657e14a6086936e3ba/615829194a67c09a9169c90a_project-iheart.png",
    logo: "https://cdn.prod.website-files.com/61535d657e14a6086936e3ba/6157eb4b9c0b9b1153d78481_iheart.svg",
    color: "#C6002B"
  },
  {
    id: 2,
    name: "Discovery",
    category: "MEDIA & ENTERTAINMENT",
    platforms: "iOS • Android",
    image: "https://cdn.prod.website-files.com/61535d657e14a6086936e3ba/615ab712e1ca21f79b0717fe_project-discovery%402x-min.png",
    logo: "https://cdn.prod.website-files.com/61535d657e14a6086936e3ba/6157ebd1516a5742b913976b_discovery.svg",
    color: "#0033A0"
  },
  {
    id: 3,
    name: "ReturnSafe",
    category: "HEALTHCARE",
    platforms: "iOS • Android • Web",
    image: "https://cdn.prod.website-files.com/61535d657e14a6086936e3ba/6158297b21b13c23d5abe7e5_project-returnsafe.png",
    logo: "https://cdn.prod.website-files.com/61535d657e14a6086936e3ba/615d3241c593a070f0e6e304_returnsafe%402x.png",
    color: "#4CAF50"
  },
  {
    id: 4,
    name: "Aloe Care Health",
    category: "HEALTHCARE IoT",
    platforms: "iOS • Android",
    image: "https://cdn.prod.website-files.com/61535d657e14a6086936e3ba/61582987d68240cdb33e97ee_project-aloe.png",
    logo: "https://cdn.prod.website-files.com/61535d657e14a6086936e3ba/6157ebed8eb7c566cde6935b_aloe.svg",
    color: "#7CB342"
  },
  {
    id: 5,
    name: "Sevenrooms",
    category: "RESTAURANT",
    platforms: "iOS",
    image: "https://cdn.prod.website-files.com/61535d657e14a6086936e3ba/615829929c0b9b1ef1d875c0_project-sevenrooms.png",
    logo: "https://cdn.prod.website-files.com/61535d657e14a6086936e3ba/6157ebfad9fa3676f5a9281b_sevenrooms.svg",
    color: "#FF5722"
  },
  {
    id: 6,
    name: "Hiki",
    category: "MEDIA & ENTERTAINMENT",
    platforms: "iOS • Android",
    image: "https://cdn.prod.website-files.com/61535d657e14a6086936e3ba/6158299f3b6b74f5d6956b6a_project-hiki.png",
    logo: "https://cdn.prod.website-files.com/61535d657e14a6086936e3ba/615d3259a50d5f4f7ef7251d_hiki-white%402x.png",
    color: "#673AB7"
  },
  {
    id: 7,
    name: "YellowHeart",
    category: "NFT-BLOCKCHAIN",
    platforms: "iOS • Android",
    image: "https://cdn.prod.website-files.com/61535d657e14a6086936e3ba/615829ac4a67c0afd369c92e_project-yellowheart.png",
    logo: "https://cdn.prod.website-files.com/61535d657e14a6086936e3ba/6157ec148e442b65e124aefb_yellowheart.svg",
    color: "#FFD700"
  },
  {
    id: 8,
    name: "Grailed",
    category: "ECOMMERCE",
    platforms: "iOS",
    image: "https://cdn.prod.website-files.com/61535d657e14a6086936e3ba/615829b86bc49c43c80740d1_project-grailed.png",
    logo: "https://cdn.prod.website-files.com/61535d657e14a6086936e3ba/6157ec1e70739cee7a73ad41_grailed.svg",
    color: "#000000"
  }
];

export const services = [
  {
    id: 1,
    icon: "Lightbulb",
    title: "Ideation",
    description: "We work with you to craft your app, identify weaknesses and the best business model."
  },
  {
    id: 2,
    icon: "Code",
    title: "Development",
    description: "We help you select the best tech stack and develop your app."
  },
  {
    id: 3,
    icon: "CheckCircle",
    title: "Validation",
    description: "We help you validate your ideas using cutting edge market research technology."
  },
  {
    id: 4,
    icon: "Palette",
    title: "Design",
    description: "We help you design wireframe and high fidelity design of your app."
  },
  {
    id: 5,
    icon: "Target",
    title: "Scoping",
    description: "We help you scope your project to help create your Minimum Viable Product (MVP) and Minimum Fundable Product (MFP)."
  },
  {
    id: 6,
    icon: "Shield",
    title: "Legal & Compliance",
    description: "We make sure your app platform is legally compliant (GDPR, CCPA)."
  },
  {
    id: 7,
    icon: "TrendingUp",
    title: "Fundraising",
    description: "We help you with your fundraising effort."
  },
  {
    id: 8,
    icon: "Rocket",
    title: "Growth Marketing",
    description: "We provide you with the support you need to acquire users, improve retention and engagement."
  }
];

export const processSteps = [
  {
    id: 1,
    tag: "Fundability Sprint",
    title: "Sculpt the Idea",
    bullets: [
      "Vet your idea against real investor patterns",
      "Kill or reshape weak concepts early",
      "Collapse the vision into one investable wedge"
    ]
  },
  {
    id: 2,
    tag: "POC Sprint",
    title: "Build the Proof",
    bullets: [
      "Build a fully functional POC using vibe coding",
      "Bake in a learning loop from day one",
      "Ship something real users can touch"
    ]
  },
  {
    id: 3,
    tag: "Raise-Ready Loop",
    title: "Package & Iterate",
    bullets: [
      "Test with users, partners, or early buyers",
      "Iterate on the wedge, not the scope",
      "Shape the narrative investors will believe"
    ]
  }
];

export const founders = [
  {
    id: 1,
    name: "Jake Aronskind",
    app: "Pepper",
    image: "https://cdn.prod.website-files.com/61535d657e14a6086936e3ba/624532bc6cba6471ed7ad5ce_Jake.jpg",
    appLogo: "https://cdn.prod.website-files.com/61535d657e14a6086936e3ba/6239b6f7601fa1d1affbe4d0_pepper%20app%20white.svg"
  },
  {
    id: 2,
    name: "Eric Grunfield",
    app: "PluggdIn",
    image: "https://cdn.prod.website-files.com/61535d657e14a6086936e3ba/62452d5c4736535a1e60f62e_5.jpg",
    appLogo: "https://cdn.prod.website-files.com/61535d657e14a6086936e3ba/6239b708fa62aaec1bb6400f_PluggdIn%20whte.svg"
  },
  {
    id: 3,
    name: "Arman Garg",
    app: "Bridge",
    image: "https://cdn.prod.website-files.com/61535d657e14a6086936e3ba/62452d8222a7795f963e1343_2.jpg",
    appLogo: "https://cdn.prod.website-files.com/61535d657e14a6086936e3ba/62963074fa149c9360fc4c16_BRIDGE-08.png"
  },
  {
    id: 4,
    name: "Kylie Chim",
    app: "Trally",
    image: "https://cdn.prod.website-files.com/61535d657e14a6086936e3ba/624532b357687785389f5fa4_Kylie.jpg",
    appLogo: "https://cdn.prod.website-files.com/61535d657e14a6086936e3ba/6239b6ebda20cd64b750e70b_trally%20white.svg"
  },
  {
    id: 5,
    name: "Lim Tianyi",
    app: "Koli",
    image: "https://cdn.prod.website-files.com/61535d657e14a6086936e3ba/62452d0fcf169b28ed687d4d_1.jpg",
    appLogo: "https://cdn.prod.website-files.com/61535d657e14a6086936e3ba/6239b719f4c05775863d5b57_Koli%20white.svg"
  }
];

export const testimonials = [
  {
    id: 1,
    quote: "Tappollo transformed our vision into a beautiful, functional app that our users love. Their expertise in mobile development is unmatched.",
    author: "Sarah Chen",
    role: "CEO & Founder",
    company: "TechStart"
  },
  {
    id: 2,
    quote: "Working with Tappollo was a game changer. They brought our app from concept to App Store featured in just 3 months.",
    author: "Michael Roberts",
    role: "Product Lead",
    company: "Innovation Labs"
  },
  {
    id: 3,
    quote: "The team at Tappollo truly understands what it takes to build products that scale. Highly recommend for any startup.",
    author: "Emily Watson",
    role: "CTO",
    company: "NextGen Apps"
  }
];

export const faqs = [
  {
    id: 1,
    question: "What is Tappollo Media?",
    answer: "Tappollo Media is an acclaimed mobile app studio helping market leaders and innovative startups execute. We are the tech partner, co-founder, and CTO that you have been looking for."
  },
  {
    id: 2,
    question: "What makes Tappollo different from other studios?",
    answer: "We're one of the few studios with apps featured in Apple commercials and we have launched startups with combined valuation of over $3B."
  },
  {
    id: 3,
    question: "What services does Tappollo offer?",
    answer: "We offer end-to-end services including ideation, design, development, validation, legal & compliance, scoping, fundraising support, and growth marketing."
  },
  {
    id: 4,
    question: "Who does Tappollo work with?",
    answer: "We work with both established market leaders like iHeartRadio, Discovery, and Walmart, as well as innovative startups looking to build their next big product. We have launched startups with combined valuation of over $3B+."
  },
  {
    id: 5,
    question: "How long does it take to build an app?",
    answer: "Timelines vary based on complexity, but we typically deliver MVPs in 12 weeks. Fundability.ai is our framework that allows you to build a POC within 4 weeks so you can raise funds and commit them towards the full MVP."
  },
  {
    id: 6,
    question: "Do you offer equity arrangements for startups?",
    answer: "Yes! We're uniquely positioned to work with startups on flexible cash/equity arrangements. We believe in partnering with founders for the long term."
  }
];